import { useTranslation } from 'react-i18next';

import { IconButton, DropdownMenu } from '@hotjar/hotsauce';

interface MoreButtonProps {
  className?: string;
  onDelete: (() => void) | undefined;
  onEdit: (() => void) | undefined;
  onShowMoreMenu?(): void;
}

export const MoreButton = ({
  className,
  onDelete,
  onEdit,
  onShowMoreMenu,
}: MoreButtonProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!onDelete || !onEdit) {
    return null;
  }

  const handleShowMoreMenu = () => {
    onShowMoreMenu?.();
  };

  return (
    <DropdownMenu
      onShow={handleShowMoreMenu}
      trigger={
        <IconButton
          className={className}
          description={t('comment:view.more')}
          icon="menu_kebab"
          kind="ghost"
          size="s"
          tooltipText={t('comment:view.more')}
        />
      }
      appendTo="parent"
    >
      <DropdownMenu.Item onClick={onEdit} icon="pencil">
        {t('comment:update.action')}
      </DropdownMenu.Item>
      <DropdownMenu.Item onClick={onDelete} icon="trash">
        {t('comment:remove.action')}
      </DropdownMenu.Item>
    </DropdownMenu>
  );
};
